import map from "lodash/map";
import reduce from "lodash/reduce";
import sortBy from "lodash/sortBy";

export function _getDeviceDistributeCsv(props, count) {
  const { top5OSBreakDown, deviceModelReport, deviceTypeReport } = props;
  const device_type_arr = ["\r\nDevice Type\r\n"];
  const device_type_sum = reduce(
    deviceTypeReport.values,
    function(sum, d) {
      return sum + d.value;
    },
    0,
  );
  map(deviceTypeReport.values, v => {
    const strDeviceType =
      device_type_sum > 0
        ? '"' +
          v.key +
          '",' +
          ((v.value / device_type_sum) * 100).toFixed(2) +
          "%,\r\n"
        : '"' + v.key + '",' + "N/A, \r\n";
    device_type_arr.push(strDeviceType);
  });

  const device_model_arr = ["\r\nDevice Model\r\n"];
  const device_model_sum = reduce(
    deviceModelReport.values,
    function(sum, d) {
      return sum + d.value;
    },
    0,
  );
  map(deviceModelReport.values, v => {
    const strDeviceModel =
      device_model_sum > 0
        ? '"' +
          v.key +
          '",' +
          ((v.value / device_model_sum) * 100).toFixed(2) +
          "%,\r\n"
        : '"' + v.key + '",' + "N/A, \r\n";
    device_model_arr.push(strDeviceModel);
  });

  const op_sys_arr = ["\r\nOperating System\r\n"];
  if (top5OSBreakDown && top5OSBreakDown.values) {
    const op_sys_sum = reduce(
      top5OSBreakDown.values,
      function(sum, d) {
        return sum + d.value;
      },
      0,
    );
    map(top5OSBreakDown.values, v => {
      const strSystem =
        op_sys_sum > 0
          ? '"' +
            v.key +
            '",' +
            ((v.value / op_sys_sum) * 100).toFixed(2) +
            "%,\r\n"
          : '"' + v.key + '",' + "N/A, \r\n";
      op_sys_arr.push(strSystem);
    });
  }

  return (
    device_type_arr.join("") + op_sys_arr.join("") + device_model_arr.join("")
  );
}

export function _getSegmentDistributeCsv(props, count) {
  const {
    lengthOfResidence,
    state,
  } = props.detailDistributionReport;

  reduce(
      lengthOfResidence.values,
      function(sum, d) {
        return sum + d.value;
      },
      0,
  );
  const top_5_state_arr = ["\r\nTop States\r\n"];
  const statesSum = reduce(
    state.values,
    function(sum, d) {
      return sum + d.value;
    },
    0,
  );
  const topStateValues = sortBy(state.values, d => -d.value);
  map(topStateValues, v => {
    const strState =
      '"' + v.key + '",' + ((v.value / statesSum) * 100).toFixed(2) + "%,\r\n";
    top_5_state_arr.push(strState);
  });

  if (count === 0) {
    return (
      "\r\nAll Segment Details \r\n" +
      top_5_state_arr.join("")
    );
  } else {
    return (
      "\r\nTop " +
      count +
      " Segment Details \r\n" +
      top_5_state_arr.join("")
    );
  }
}

export function _getCultureCsv(props) {
  const formatData = arr => {
    if (!arr || !(arr instanceof Array) || arr.length === 0) return [];
    const allCount = arr.reduce((a, b) => {
      if (typeof a !== "number") return a.value + b.value;
      else return a + b.value;
    });
    arr.forEach(it => {
      it.percentage = it.value / allCount;
    });
    return arr;
  };
  const data = props.cultureCodeReport || {};
  const json = Object.keys(data).join();
  let aaAcculturation = [];
  let hhAcculturation = [];
  data.acculturation &&
    data.acculturation.values &&
    data.acculturation.values.forEach(it => {
      const keyName = it.key.split(":");
      it._key = keyName[0];
      it.middleVal = keyName[1];
      if (it.key.includes("AA")) {
        aaAcculturation.push(it);
      } else {
        hhAcculturation.push(it);
      }
    });
  const acculturation = formatData(
    data.acculturation && data.acculturation.values,
  );
  const aa = formatData(aaAcculturation);
  const hh = formatData(hhAcculturation);
  const ethnicity = formatData(data.ethnicity && data.ethnicity.values);
  const region = formatData(data.region && data.region.values);
  let str = "\r\nEthnicity,\r\n";
  str += "\r\n";
  sortBy(ethnicity, "value")
    .reverse()
    .forEach(it => {
      const val = Math.round(it.percentage * 10000);
      if (val > 0) {
        str += `${it.key},${val / 100 + "%"},\r\n`;
      }
    });
  str += "\r\nRegion,\r\n";
  str += "\r\n";
  sortBy(region, "value")
    .reverse()
    .forEach(it => {
      const val = Math.round(it.percentage * 10000);
      if (val > 0) {
        str += `${it.key},${val / 100 + "%"},\r\n`;
      }
    });
  str += "\r\nAcculturation,\r\n";
  str += "\r\nHispanicity\r\n\r\n";
  sortBy(hh, "value")
    .reverse()
    .forEach(it => {
      const val = Math.round(it.percentage * 10000);
      if (val > 0) {
        str += `${it._key},${val / 100 + "%"},\r\n`;
      }
    });

  str += "\r\nAsianicity\r\n\r\n";
  sortBy(aa, "value")
    .reverse()
    .forEach(it => {
      const val = Math.round(it.percentage * 10000);
      if (val > 0) {
        str += `${it._key},${val / 100 + "%"},\r\n`;
      }
    });

  return str;
}



// WEBPACK FOOTER //
// ./src/components/Insights/distribution/pdfHelper.js